import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import defaultTheme from '../theme';

const ThemeProvider = ({ theme = defaultTheme, ...props }) => {
  const mergedTheme = Object.assign({}, defaultTheme, theme);

  return <EmotionThemeProvider theme={mergedTheme} {...props} />;
};

ThemeProvider.propTypes = {
  theme: PropTypes.shape({})
};

ThemeProvider.defaultProps = {
  theme: {}
};

export default ThemeProvider;



// WEBPACK FOOTER //
// ./src/components/ThemeProvider.jsx